import { ActionIcon, Group, Tooltip, Text } from "@mantine/core";
import {
  IconEdit,
  IconTrash,
} from "@tabler/icons-react";
import type { ColumnDef } from "@tanstack/react-table";
import type { IProyecto } from "../../../modelos/Proyectos/entidades/IProyecto";

interface ColumnasTablaProyectoParams {
  manejarEdicionProyecto: (proyecto: IProyecto) => void;
  manejarEliminacionProyecto: (proyecto: IProyecto) => void;
}

export const columnasTablaProyecto = ({
  manejarEdicionProyecto,
  manejarEliminacionProyecto,
}: ColumnasTablaProyectoParams): ColumnDef<IProyecto>[] => [
    {
      id: "actions",
      header: "Acciones",
      cell: ({ row: fila }) => (
        <Group gap={4} justify="center">
          <Tooltip label="Editar" style={{ fontSize: '10px', padding: '3px 5px' }} withArrow>
            <ActionIcon
              color='var(--mantine-color-primary-0)'
              variant="transparent"
              radius="sm"
              size="sm"
              onClick={() => manejarEdicionProyecto(fila.original)}
            >
              <IconEdit size={18} />
            </ActionIcon>
          </Tooltip>
          <Tooltip style={{ fontSize: '10px', padding: '3px 5px' }} label="Eliminar" withArrow>
            <ActionIcon
              color="var(--mantine-color-primary-0)"
              variant="transparent"
              radius="sm"
              size="sm"
              onClick={() => manejarEliminacionProyecto(fila.original)}
            >
              <IconTrash size={18} />
            </ActionIcon>
          </Tooltip>
        </Group>
      ),
    },
    { accessorKey: "Nombre", header: "Nombre" },
    { accessorKey: "NitProyecto", header: "Identificación" },
    { accessorKey: "Pais.Nombre", header: "País" },
    {
      accessorKey: "Direccion", header: "Dirección",
      cell: ({ row }) => {
        const direccion: string = row.original.Direccion ?? "";
        const maxCaracteres = 50;
        const esLarga = direccion.length > maxCaracteres;
        const direccionCorta = esLarga
          ? direccion.substring(0, maxCaracteres) + "..."
          : direccion;

        return esLarga ? (
          <Tooltip fz="xs" label={direccion} withArrow withinPortal>
            <Text fz="xs">{direccionCorta}</Text>
          </Tooltip>
        ) : (
          <Text fz="xs">{direccionCorta}</Text>
        );
      },

    },
    { accessorKey: "Regional.Nombre", header: "Regional" },
    { accessorKey: "Zona.Nombre", header: "Zona" },
    { accessorKey: "Ruta", header: "Ruta" },
    {accessorKey: "Ciudad.Nombre", header: "Ciudad"}

  ];
